import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IconView, IconViewSizes } from '@gem/ui-kit';

import { Avatar, AvatarTypes } from 'APP/components/Avatar/Avatar';
import { ConfirmationType } from 'APP/model/calendar/calendar.types';
import { User } from 'APP/store/Users/User/User';

import { useCalendarParticipantAvatarPresenter } from './CalendarParticipantAvatar.presenter';
import styles from './CalendarParticipantAvatar.styles.m.css';

interface ICalendarParticipantAvatarProps {
  userData: User | null;
  confirmationType: ConfirmationType;
}

export const CalendarParticipantAvatar: FC<ICalendarParticipantAvatarProps> = observer((props) => {
  const { userData, confirmationType } = props;
  const presenter = useCalendarParticipantAvatarPresenter({ confirmationType });

  const containerClassName = classNames(
    styles.container,
    styles[`confirmation-type-${presenter.confirmationTypeName}`]
  );

  return (
    <div className={containerClassName}>
      <Avatar
        type={AvatarTypes.Round_0}
        title={userData?.displayName || ''}
        url={userData?.avatarUrl || ''}
        backgroundColorIndex={userData?.avatarColorIndex || '1'}
      />
      <div className={styles.status}>
        <IconView
          size={IconViewSizes.Small}
          Icon={presenter.Icon}
          className={styles.icon}
        />
      </div>
    </div>
  );
});
